import { User } from '../user/user.state'

export enum ActionType {
  // Generic Actions
  ADDED = 'ADDED',
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  ASSIGNED = 'ASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
  GENERATED = 'GENERATED',
  SENT = 'SENT',
  CANCELLED = 'CANCELLED',
  APPLIED_FOR = 'APPLIED_FOR',
  TERMINATED = 'TERMINATED',
  EXPORTED = 'EXPORTED',
  IMPORTED = 'IMPORTED',

  // Custom Actions
  USER_LOGIN = 'USER_LOGIN',
  USER_REGISTRATION = 'USER_REGISTRATION',
  USER_UPDATE = 'USER_UPDATE',
  USER_DELETE = 'USER_DELETE'
}

/**
 * Defines the types of entities that can be a target of an action.
 */
export enum TargetEntityType {
  EMPLOYEE = 'EMPLOYEE',
  REPORTING_MANAGER = 'REPORTING_MANAGER',
  REQUEST_MANAGER = 'REQUEST_MANAGER',
  PROFILE = 'PROFILE',
  BUSINESS = 'BUSINESS',
  OFFICE = 'OFFICE',
  ROLE = 'ROLE',
  BANK = 'BANK',
  HR_MANAGER = 'HR_MANAGER'
  // ... etc.
}

export interface LogDetails {
  changes?: {
    field: string // The name of the property that changed, e.g., "email" or "role"
    oldValue: string | null
    newValue: string | null
  }
  misc?: Record<string, unknown>
  errorMessage?: string
}

export interface TaskLog {
  id: string
  actorId: string
  actorName: string
  actor: User | null
  actionType: ActionType
  targetEntityType: TargetEntityType | null
  targetEntityId: string | null
  targetEntityInfo: string | null
  details?: LogDetails | null
  ipAddress?: string
  isAuditLog?: boolean
  affectedEntityType: TargetEntityType | null
  affectedEntityId: string | null
  affectedEntityInfo: string | null
  status: 'Success' | 'Error'
  createdAt: string // ISO date string
  message: string
  segments: LogMessageSegment[]
}

export interface LogMessageSegment {
  text: string
  link?: string // required for Angular routerLink
}

export interface BusinessLogFilters {
  actorId?: string
  targetEntityId?: string
  affectedEntityId?: string
  isAuditLog?: boolean
  searchQuery?: string
}

export interface TaskLogState {
  totalCount: number
  tasklogs: TaskLog[]
  totalBusinessLogCount: number
  businessTasklogs: TaskLog[]
  loading: boolean
  error: string | null
}
